import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { EmpresasService } from 'app/main/a2w/supervisor/cadastros/empresas/empresas.service';
import { VendedoresService } from 'app/main/a2w/supervisor/cadastros/parceiros-negocios/vendedor/vendedores.service';
import { RegrasNegociosPluguinsService } from 'app/main/a2w/supervisor/configuracoes/regras-negocios/regras-negocios.service';
import { EnumFuncoes } from 'app/shared/enum.service';
import { environment } from 'environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PermissionModulesService } from './permission-modules.service';
import { User } from './user.model';
import { ValidaAcessoResponse } from './valida-acesso.model';


@Injectable({
    providedIn: 'root'
})
export class AuthenticationService {

    private _regrasService: RegrasNegociosPluguinsService;

    constructor(
        private http: HttpClient,
        private _modules: PermissionModulesService,
        private _empresasService: EmpresasService,
        private _vendedoresService: VendedoresService,
        private injector: Injector
    ) {
        
        this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
        this.currentUser = this.currentUserSubject.asObservable();
    }

    public get currentUserValue(): User {
        return this.currentUserSubject.value;
    }

    private currentUserSubject: BehaviorSubject<User>;
    public currentUser: Observable<User>;

    // helper methods

    private refreshTokenTimeout;

    public setCurrentUserSubject(user){
        localStorage.setItem('currentUser', JSON.stringify(user));
        this.currentUserSubject.next(user);
    }

    login(usuario: string, senha: string) {
        return this.http.post<any>(`${environment.apiUrl2}/v1/user/login`, { username: usuario, password: senha, local: 'web', app: 'web' })
            .pipe(map((user: User) => {
                if (user && user.accessToken) {
                    this.salvaLocal(user);
                }
                return user;
            }));
    }

    salvaLocal(user, token?:string, expiresIn?: number, tipo?: boolean){

        if(tipo){ //SSO

            const usuario: User = {
                accessToken: token,
                accountId: user.accountId,
                accountImage: null, //não tem
                apiKeyGoogleMaps: user.apiKeyGoogleMaps,
                expiresIn: expiresIn,
                flagArmazenagem: user.flagArmazenagem,
                flagOfertaEstruturada: user.flagOfertaEstruturada,
                flagRdv: user.flagRdv,
                moduloAtividades: user.moduloAtividades,
                moduloPedidos: user.moduloPedidos,
                subTenant: "",
                userDetails: user,
                usuarioToken: undefined,
                roles: [],
                visualizarOperacoesColaboradoresVinculados: user?.visualizarOperacoesColaboradoresVinculados || false
            }

            // armazena detalhes do usuário e credenciais básicas de autenticação no armazenamento local para manter o usuário logado entre as atualizações da página
            localStorage.setItem('currentUser', JSON.stringify(usuario));
            this.currentUserSubject.next(usuario);

            // REGRAS
            this.getRolesAccountRoles();
        } else {
            // armazena detalhes do usuário e credenciais básicas de autenticação no armazenamento local para manter o usuário logado entre as atualizações da página
            localStorage.setItem('currentUser', JSON.stringify(user));
            this.currentUserSubject.next(user);

            // REGRAS
            this.getRolesAccountRoles();
        }        

        // EMPRESAS
        this.getAllEmpresas();
    }

    
     getRolesAccountRoles() {
        // Inicializa o serviço de regras usando o injector
        if (!this._regrasService) {
            this._regrasService = this.injector.get(RegrasNegociosPluguinsService);
        }
        this._regrasService.getRolesAccountRoles().then((res) => {
            localStorage.setItem('regras', JSON.stringify(res));
        });
    }
        
    logout() {
        // remove usuário do armazenamento local para fazer logout do usuário
        localStorage.removeItem('currentUser');
        localStorage.removeItem('regras');
        // this.stopRefreshTokenTimer();
        this.currentUserSubject.next(null);
        this._modules.resetModules();
    }

    getAllEmpresas(){
        this._empresasService.getAll().then(res => {
            let empresas = [];
            res.map(x => empresas.push({
                id: x.id,
                flagMatriz: x.flagMatriz,
                flagLogoEmpresas: x.flagLogoEmpresas,
                linkRelatorio: x.linkRelatorio 
            }));
            localStorage.setItem('empresas', JSON.stringify(empresas));
        });
    }

    refreshToken() {
        return this.http.post<any>(`${environment.apiUrl}/users/refresh-token`, {}, { withCredentials: true })
            .pipe(map((user) => {
                console.log(JSON.stringify(user));
                localStorage.setItem('currentUser', JSON.stringify(user));
                this.currentUserSubject.next(user);
                this.startRefreshTokenTimer();
                return user;
            }));
    }

    private startRefreshTokenTimer() {
        // parse json object from base64 encoded jwt token
        const expiracao = JSON.parse(atob(this.currentUserValue.expiresIn.toString()));

        // set a timeout to refresh the token a minute before it expires
        const expires = new Date(expiracao * 1000);
        const timeout = expires.getTime() - Date.now() - (60 * 1000);
        this.refreshTokenTimeout = setTimeout(() => this.refreshToken().subscribe(), timeout);
    }

    private stopRefreshTokenTimer() {
        clearTimeout(this.refreshTokenTimeout);
    }

    setaDadosUsuario(obj){

        const userDetails = obj.userDetails;
        userDetails.listaFiliaisGestor = [];
        userDetails.listaUsuariosGestor = [];
        userDetails.listaClientesDistribuidor = [];
        userDetails.listaFiliaisVendedor = [];
        userDetails.listaFiliaisVendedorOperacoes = [];

        if (userDetails.userRules.length > 0) {

                    for (const userRules of userDetails.userRules){
                        if ((userRules.funcao == EnumFuncoes.Administrador && userRules.ativo) || (userRules.funcao == EnumFuncoes.Gestor && userRules.ativo)) {

                            // BUSCA FILIAIS GESTOR
                            if (userDetails.filiaisGestor) {

                                const filiaisIds = this.stringToArray(userDetails.filiaisGestor, ',');

                                const i = filiaisIds.length;
                                if (i > 0){
                                    filiaisIds.forEach((id, index) => {

                                        this._empresasService.getById(id)
                                            .then(emp => {
                                                if (!userDetails.listaFiliaisGestor.find(x => x.id == emp.id)){
                                                        userDetails.listaFiliaisGestor.push(emp);
                                                }
                                            });

                                        if (i == (index + 1)){
                                            // FAZ A ORDENACAO DA LISTA AO FINALIZAR O ARRAY
                                            this.orderFiliaisByRazaoSocial(userDetails.listaFiliaisGestor);
                                        }

                                    });
                                }

                            }

                            // BUSCA VENDEDORES GESTOR
                            if (userDetails.usuariosGestor) {

                                const usuariosIds = this.stringToArray(userDetails.usuariosGestor, ',');

                                const i = usuariosIds.length;
                                if (i > 0){
                                    usuariosIds.forEach((id, index) => {

                                        this._vendedoresService.getById(id)
                                            .then(vend => {
                                                if (!userDetails.listaUsuariosGestor.find(x => x.id == vend.id)){
                                                    userDetails.listaUsuariosGestor.push(vend);
                                                }
                                            });

                                        if (i == (index + 1)){
                                            this.adicionaVendedorUsuarioLogado(userDetails);
                                        }

                                    });
                                }else{
                                    this.adicionaVendedorUsuarioLogado(userDetails);
                                }
                            }

                        }

                        if (userRules.funcao == EnumFuncoes.DistribuidorLojista && userRules.ativo) {

                            if (userDetails.clientesDistribuidor) {

                                // BUSCA FILIAIS QUE QUER VENDER
                                const clientesIds = this.stringToArray(userDetails.clientesDistribuidor, ',');

                                const i = clientesIds.length;
                                if (i > 0){
                                    clientesIds.forEach((id, index) => {
                                        this._empresasService.getById(id)
                                            .then(emp => {
                                                if (!userDetails.listaClientesDistribuidor.find(x => x.id == emp.id)){
                                                    userDetails.listaClientesDistribuidor.push(emp);
                                                }
                                            });

                                        if (i == (index + 1)){
                                            // FAZ A ORDENACAO DA LISTA AO FINALIZAR O ARRAY
                                            this.orderFiliaisByRazaoSocial(userDetails.listaClientesDistribuidor);
                                        }
                                    });
                                }

                            }
                        }
                    }
                }

            // });

        if (userDetails.vendedorId > 0){
                this._vendedoresService.getById(userDetails.vendedorId)
                    .then(res => {
                        userDetails.vendedorUsuarioLogado = res;
                        if (res.filiais.length > 0){
                            res.filiais.forEach(filial => {
                                this._empresasService.getById(filial.empresaId)
                                    .then(y => {
                                        if (userDetails.listaFiliaisVendedor.filter(x => x.id == y.id).length == 0){
                                            userDetails.listaFiliaisVendedor.push(y);
                                        }
                                    });
                            });
                            // userDetails.filiaisVendedor = this.orderPartness(userDetails.filiaisVendedor);
                        }
                    });
            }

        return userDetails;
    }
    
    stringToArray(string, delimitador, int = null){
        /*
           objetivo: retorna um array a partir de uma string
           delimitador: qual o delimitador para explodir a string
       */
        if (string){
            const array = string.split(delimitador);

            if (int){
                array.forEach((element, index) => {
                    array[index] = parseInt(element);
                });

                return array;
            }else{
                return array;
            }
       }

        return [];
   }

   adicionaVendedorUsuarioLogado(obj) {

        const userDetails = obj;

        if (userDetails.vendedorId > 0) {
            if (userDetails.listaUsuariosGestor.length > 0) {
                if (userDetails.listaUsuariosGestor.filter(x => x.id == userDetails.vendedorId).length == 0){
                    this._vendedoresService
                        .getById(userDetails.vendedorId)
                        .then((res) => {
                            userDetails.listaUsuariosGestor.push(res);
                            this.orderVendedoresByNomeVendedor(userDetails.listaUsuariosGestor);
                        });
                }else{
                    // FAZ A ORDENACAO DA LISTA AO FINALIZAR O ARRAY
                    this.orderVendedoresByNomeVendedor(userDetails.listaUsuariosGestor); 
                }
            }else{
                if (userDetails.listaUsuariosGestor.filter(x => x.id == userDetails.vendedorId).length == 0){
                    this._vendedoresService
                        .getById(userDetails.vendedorId)
                        .then((res) => {
                            userDetails.listaUsuariosGestor.push(res);
                        });
                }
            }
        }

        return userDetails;

    }

    removeAccent(text: any) {
        return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }

    orderFiliaisByRazaoSocial(filial) {
        return filial.sort((a, b) => a.razaoSocial.localeCompare(b.razaoSocial));
    }

    orderVendedoresByNomeVendedor(vendedores){
        return vendedores.sort((a, b) => a.nomeVendedor.localeCompare(b.nomeVendedor));
    }

    getRegras(): any[] { // pega as regras do localStorage sem fazer requisição
        return JSON.parse(localStorage.getItem('regras')) || [];
    }

    validaAcesso(token?: string): Promise<ValidaAcessoResponse> {
        return new Promise((resolve, reject) => {
            
            const headers = new HttpHeaders({
                'Authorization': `Bearer ${token}`
            });
            this.http
                .get<ValidaAcessoResponse>(`${environment.apiUrl2}/v1/user/valida-acesso?local=web`, { headers })
                .subscribe((response) => {
                    resolve(response);
                }, reject);
        });        
    }

}
